import { Step } from "react-joyride";

export const tourStepsReports = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Reports store a record after each finished session: items shown, time taken, missed, and skipped. Teachers can use this to see progress.",
      disableBeacon: true,
    },
    {
      target: ".reports-charts",
      content:
        "These totals show how many sessions you have finished, how many collections were practiced, and recent activity.",
    },
    {
      target: ".reports-overview",
      content:
        "Charts show completions by collection and over time. Missed and skipped bars help spot collections that need more practice.",
    },
    {
      target: ".session-reports-list",
      content:
        "Each card is one session, with the collection name and the four stats. Older sessions from before this tracking may show zeros for time, missed, and skipped.",
    },
  ];

  return steps;
};
